@if (field) {
<ng-container>
  <span *ngIf="field.errors?.['required'] && field.touched">
    {{ 'thisFieldIsRequired' | translate }}
  </span>

  <span *ngIf="field.errors?.['pattern'] && field.touched">
    {{ 'thisFieldIsInvalid' | translate }}
  </span>

  <span *ngIf="field.errors?.['email'] && field.touched">
    {{ 'invalidEmail' | translate }}
  </span>

  <span *ngIf="field.errors?.['min'] && field.touched">
    {{ 'minimumValueValidation' | translate }} {{ minimumValue }}
  </span>

  <span *ngIf="field.errors?.['max'] && field.touched">
    {{ 'maximumValueValidation' | translate }} {{ maximumValue }}
  </span>

  <span *ngIf="field.errors?.['minlength'] && field.touched">
    {{ 'minLengthValidation' | translate : {count: minLength} }}
  </span>

  <span *ngIf="field.errors?.['fieldMismatch'] && field.touched">
    {{ field.errors?.['fieldMismatch'] | translate }}
  </span>
</ng-container>
}@else {
<span *ngIf="form.errors?.['allOrNone'] && form.touched">
  {{ 'plsFillEitherAllOrNoFields' | translate }}
</span>
}